import * as React from "react";
import ProfileAttributesContainer from "../ProfileAttributesContainer";
import ProfileCompanyDetailsContainer from "../ProfileCompanyDetailsContainer";
import ProfileGroupsContainer from "../ProfileGroupsContainer";
import ProfileNameContainer from "../ProfileNameContainer";
import ProfilePrimaryContactContainer from "../ProfilePrimaryContactContainer";
import ProfileTeamMembersContainer from "../ProfileTeamMembersContainer";
import ProfileUserActivitiesContainer from "../ProfileUserActivitiesContainer";

const ProfileContainer = () => {
  return (
    <div className="bg-white border">
      <div className="grid bg-gray-100 border-b md:grid-cols-2">
        <div className="p-8">
          <ProfileNameContainer />
        </div>
        <div className="p-8 border-t md:border-t-0">
          <ProfileCompanyDetailsContainer />
        </div>
      </div>

      <div className="grid md:grid-cols-2">
        <div>
          <div className="p-8">
            <ProfilePrimaryContactContainer />
          </div>
          <div className="p-8 border-t md:border-t-0">
            <ProfileAttributesContainer />
          </div>
          <div className="p-8 border-t md:border-t-0">
            <ProfileGroupsContainer />
          </div>
        </div>
        <div>
          <div className="px-8 py-8 border-t md:border-t-0">
            <ProfileUserActivitiesContainer />
          </div>
          <div className="px-8 py-4 border-t md:border-t-0">
            <ProfileTeamMembersContainer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileContainer;
